// 按钮权限集合
export const PERMISSION_MAP = {
  // 工作台菜单权限 - 门店负责人 (accountType=0) 区域负责人 (accountType=1) 分公司负责人 (accountType=2)
  customer_consume_points: {
    0: 'store_workbench_customer_consume_points',
  },
  customer_send_points: {
    0: 'store_workbench_customer_send_points',
  },
  customer_blacklist: {
    0: 'store_workbench_customer_blacklist',
  },
  customer_mute: {
    0: 'store_workbench_customer_mute',
  },
  customer_unbind_change_binding: {
    0: 'store_workbench_customer_unbind_change_binding',
  },
  customer_place_order_for_customer: {
    0: 'store_workbench_customer_place_order_for_customer',
  },
  customer_member_review: {
    0: 'store_workbench_customer_member_review',
  },
  customer_member_level_upgrade_downgrade: {
    0: 'store_workbench_customer_member_level_upgrade_downgrade',
  },
  customer_remove_member: {
    0: 'store_workbench_customer_remove_member',
  },

  // 菜单相关
  // * 客户管理相关
  customer_information: {
    0: 'store_workbench_customer_information',
    1: 'region_workbench_store_data',
    2: 'company_workbench_regional_data',
  },
  customer_management: {
    0: 'store_workbench_customer_management',
    1: 'region_workbench_store_data_customer_management',
    2: 'company_workbench_regional_data_customer_management',
  },
  customer_member_management: {
    0: 'store_workbench_customer_member_management',
  },
  customer_consumption_ranking: {
    0: 'store_workbench_customer_consumption_ranking',
  },
  follow_data_performance_report: {
    1: 'region_workbench_store_data_performance_report',
    2: 'company_workbench_regional_data_performance_report',
  },
  follow_data_product_statistics: {
    1: 'region_workbench_store_data_product_statistics',
    2: 'company_workbench_regional_data_product_statistics',
  },
  follow_data_follow_commission: {
    1: 'region_workbench_store_data_store_commission',
    2: 'company_workbench_regional_data_store_commission',
  },
  follow_data_commodity_operation: {
    0: 'store_workbench_marketing_commodity_management',
    1: 'region_workbench_store_commodity_operation',
    2: 'company_workbench_regional_commodity_operation',
  },
  // 招募门店、区域
  follow_data_follow_recruitment: {
    1: 'region_workbench_store_data_store_recruitment',
    2: 'company_workbench_regional_data_regional_recruitment',
  },
  follow_data_follow_management: {
    1: 'region_workbench_store_data_store_management',
    2: 'company_workbench_regional_data_regional_management',
  },

  // * 排行榜相关
  follow_ranking: {
    1: 'region_workbench_store_ranking',
    2: 'company_workbench_regional_ranking',
  },
  follow_ranking_operation_ranking: {
    1: 'region_workbench_store_ranking_operation_ranking',
    2: 'company_workbench_regional_ranking_operation_ranking',
  },
  follow_ranking_commission_ranking: {
    1: 'region_workbench_store_ranking_commission_ranking',
    2: 'company_workbench_regional_ranking_commission_ranking',
  },

  // * 内部管理相关
  internal_management: {
    0: 'store_workbench_internal_management',
  },
  // 招募代理
  internal_agent_recruitment: {
    0: 'store_workbench_internal_agent_recruitment',
  },
  internal_agent_management: {
    0: 'store_workbench_internal_agent_management',
  },
  internal_agent_performance: {
    0: 'store_workbench_internal_agent_performance',
  },

  // * 营销管理相关
  marketing: {
    0: 'store_workbench_marketing',
  },
  marketing_collect_cards_for_rewards: {
    0: 'store_workbench_marketing_collect_cards_for_rewards',
  },
  marketing_payment_with_gifts: {
    0: 'workbench_marketing_payment_with_gifts',
  },

  // * 数据管理相关
  data_management: {
    0: 'store_workbench_data_management',
  },
  data_management_store_data: {
    0: 'store_workbench_data_management_store_data',
  },
  data_management_business_reports: {
    0: 'store_workbench_data_management_business_reports',
  },

  // * 配套工具相关
  supporting_tools: {
    0: 'store_workbench_supporting_tools',
    1: 'region_workbench_supporting_tools',
    2: 'company_workbench_supporting_tools',
  },
  supporting_tools_in_transit_delivery: {
    0: 'store_workbench_supporting_tools_in_transit_delivery',
  },
  supporting_tools_store_information: {
    0: 'store_workbench_supporting_tools_store_information',
  },
  supporting_tools_account_management: {
    0: 'store_workbench_supporting_tools_account_management',
    1: 'region_workbench_supporting_tools_account_management',
    2: 'company_workbench_supporting_tools_account_management',
  },
  supporting_tools_transaction_complaints: {
    0: 'store_workbench_supporting_tools_transaction_complaints',
    1: 'region_workbench_supporting_tools_transaction_complaints',
    2: 'company_workbench_supporting_tools_transaction_complaints',
  },
}
